import { Globe2, MapPin } from "lucide-react";

export const REGION_CONFIG = {
  ALL: { label: "All India", icon: Globe2, color: "#1A1A2E", bg: "bg-[#1A1A2E]", text: "text-white", accent: "#1A1A2E" },
  GJ: { label: "Gujarat", icon: MapPin, color: "#C0272D", bg: "bg-[#C0272D]", text: "text-white", accent: "#C0272D" },
  RJ: { label: "Rajasthan", icon: MapPin, color: "#F5A623", bg: "bg-[#F5A623]", text: "text-white", accent: "#F5A623" },
};

export const RegionSwitcher = ({ active, onChange, isSuperAdmin = true, dataTestId = "region-switcher" }) => {
  if (!isSuperAdmin) return null;
  const regions = ["ALL", "GJ", "RJ"];
  return (
    <div
      className="flex items-center gap-1 p-1 bg-slate-100 dark:bg-slate-800 rounded-xl"
      data-testid={dataTestId}
    >
      {regions.map((r) => {
        const cfg = REGION_CONFIG[r];
        const isActive = active === r;
        return (
          <button
            key={r}
            onClick={() => onChange(r)}
            className={`flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
              isActive
                ? `${cfg.bg} ${cfg.text} shadow-md`
                : "text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200 hover:bg-white dark:hover:bg-slate-700"
            }`}
            data-testid={`region-btn-${r}`}
          >
            <cfg.icon className="w-3.5 h-3.5" />
            {cfg.label}
          </button>
        );
      })}
    </div>
  );
};

export default RegionSwitcher;
